import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';

import { SEARCH_QUERY_CLASS_NAME } from './LocalStyleRuleSearch.constants';
import { formatStyleRuleName } from '../../services/format';

export function appendSearchQueryToOptions(options, searchQuery) {
  if (!_isEmpty(searchQuery)) {
    const searchQueryOption = {
      key: searchQuery,
      value: searchQuery,
      text: searchQuery,
      className: SEARCH_QUERY_CLASS_NAME,
    };

    if (!_some(options, { value: searchQuery })) {
      return [searchQueryOption, ...options];
    }
  }

  return options;
}

export function createStyleRuleSearchOptions(styleRuleConfigurations, searchQuery) {
  let options = styleRuleConfigurations.map(({ name }) => ({
    key: name,
    value: name,
    text: formatStyleRuleName(name),
  }));

  if (!_isEmpty(searchQuery)) {
    options = appendSearchQueryToOptions(options, searchQuery);
  }

  return options;
}
